<div class="common-container" *ngIf="!activeTab.clearFraudIdentityData.step1Active && !activeTab.clearIdentityData.step1Active">
  <div >
      <p class="steps-content step1-content hide1">
        {{CL_constant.SUBTITLE}}
      </p>
      <section class="radio-selection hide1">
        <mat-radio-group color="primary" class="account-selection example-radio-group" disableRipple aria-label="Select an option"
          [(ngModel)]="activeTab.clearIdentityData.identityVerificationType" 
          (change)="onRadioChange($event.value)">
          <mat-radio-button class="example-radio-button" 
          *ngFor="let selection of selections" [value]="selection" [disabled]="isClearSelectionDisabled(selection)">
            {{selection}}
          </mat-radio-button>
        </mat-radio-group>
      </section>
    </div>

   
    <div *ngIf="isWebFreezeCheckVisible()" >
     
      <p><mat-checkbox class="wrap-checkbox" color="primary"
          [(ngModel)]="rootScope.activeCustTab.clearFraudIdentityData.isWebFreezeChecked"
          (change)="onWebFreezeCheckChange($event)">Confirm that you have completed the required web freeze steps before
          proceeding with AIDV.</mat-checkbox></p>
    </div>

     <div class="btn-refresh-container flex">
      <div class="btn-controls">  
         
        <f-button [text]="CL_constant.START_AIDV_BUTTON" [title]="CL_constant.START_AIDV_BUTTON" 
          [disabled]="fraudStartADIVbuttonDisabled()" type="button" variant="progressive" class="hide1"
          (buttonClicked)="fraudStartADIVbutton()" *ngIf="!activeTab.clearFraudIdentityData.step1Active && rootScope.activeCustTab.clearIdentityData.identityVerificationType !== affidavitTypeConstants.ACCOUNT_ACCESS"></f-button>
      
      </div>
    </div>
</div>

<div class="clear-container" >
  <div class="pin-container hide1">
    <div class="step-container flex justify-space-between" *ngIf="activeTab.clearIdentityData.step1Active">
      <!-- step-1 -->
      <span class="step-val" [ngClass]="{active:activeTab.clearIdentityData.step1Active}">
        <span class="step-circle" [ngClass]="clearService.clearStepsClass('1')">
          <span class="hide1" *ngIf="activeTab.clearIdentityData.step1Complete"> <f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span>
          <span class="step-no" *ngIf="!activeTab.clearIdentityData?.step1Complete">1</span>
        </span>{{CL_constant.TITLE_STEP1}}
      </span>
      <!-- step-2 -->
      <span class="step-val" [ngClass]="{active:activeTab.clearIdentityData.step2Active}">
        <span class="step-circle" [ngClass]="clearService.clearStepsClass('2')">
          <span class="hide1" *ngIf="activeTab.clearIdentityData.step2Complete||activeTab.clearIdentityData.step2Failed"> <f-icon [iconConfig]="{iconName: activeTab.clearIdentityData.step2Failed ? 'xmark' : 'check', iconType: 'solid', iconSize: 's'}"></f-icon></span>
          <span class="step-no" *ngIf="!activeTab.clearIdentityData?.step2Complete && !activeTab.clearIdentityData?.step2Failed">2</span>
        </span>{{CL_constant.TITLE_STEP2}}
      </span>
      <!-- step-3 -->
      <span class="step-val" [ngClass]="{active: activeTab.clearIdentityData.step3Active }">
        <span class="step-circle" [ngClass]="clearService.clearStepsClass('3')">
          <span class="hide1"  *ngIf="activeTab.clearIdentityData.step3Complete||activeTab.clearIdentityData.step3Failed"> 
            <f-icon [iconConfig]="{iconName: activeTab.clearIdentityData.step3Failed ? 'xmark' : 'check', iconType: 'solid', iconSize: 's'}"></f-icon>
          </span>
          <span class="step-no"  *ngIf="!activeTab.clearIdentityData?.step3Complete&& !activeTab.clearIdentityData?.step3Failed" >3</span>
        </span>{{CL_constant.TITLE_STEP3}}
      </span>
    </div>
  </div>
              <div class="check-aidv-eligibility">
              
                <!-- For step-1 content Checkbox selection -->
                <div class="checkbox-header" *ngIf="activeTab.clearIdentityData.step1Active&&!activeTab.clearIdentityData.step1Part2">
                  <f-checkbox-group 
                    checkbox-group-name=" Select all checkboxes to validate CLEAR eligibility. If the customer isn’t eligible, follow the standard authentication methods."
                    [checkboxItems]="rootScope.activeCustTab.clearIdentityData.step1CheckList" variant="vertical" allow-multiple
                    (checkboxChecked)="clearService.clearCheckEligibility($event)">
                  </f-checkbox-group>
                </div>
                
                           
              
                <!-- For step-1 Government ID Verification -->
                <div class="error-wrapper"
                  *ngIf="((activeTab.clearIdentityData?.step1Part3&&!activeTab.clearIdentityData.step1Complete)||(!activeTab.clearIdentityData.step2Complete&&activeTab.clearIdentityData.step1Part3ToggleSelection))">
                  <f-alert variant="info"> If the customer cannot obtain their valid government-issued ID within 5 minutes, instruct
                    customer to call back to complete the verification process once they have it available. Press cancel to end AIDV.
                  </f-alert>
                  <div class="sm-selector" >
                
                    <span class="sm-title">Does the customer have their government-issued ID available now? </span>
                
                
                    <f-toggle-switch label-left="No" label-right="Yes" (toggleSwitchClicked)="onToggleChange($event)"
                      [isOn]="activeTab.clearIdentityData?.step1Part3ToggleSelection">
                    </f-toggle-switch>
                  </div>
                
                </div>
                <div *ngIf="activeTab.clearIdentityData.step1Part2 
                                && !activeTab.clearIdentityData.step1Part3
                                                          &&!activeTab.clearIdentityData.step2Active">
                <section class="error-wrapper">
                <f-alert variant="info"> {{CL_constant.STEP2PART2_INFO}}
                </f-alert></section>
                <div class="pin-content step1-content" >
                  <p>{{CL_constant.STEP1PART2}}</p>
             
                </div>
                <section class="radio-selection" >
                  <mat-radio-group color="primary" class="account-selection" disableRipple aria-label="Select an option"
                    [(ngModel)]="activeTab.clearIdentityData.step1RadioSelection">
              
                    <mat-radio-button *ngFor="let selection of accountAccessOptions " [value]="selection.value">
                      <b>{{selection.value}} </b>{{selection.describe}}</mat-radio-button>
                  </mat-radio-group>
                </section>
              </div>
              <!-- Step 2 for AIDV content -->
                <div class="pin-content step2-content" *ngIf="activeTab.clearIdentityData?.step2Active
                                && !activeTab.clearIdentityData.step3Active&&!activeTab.clearIdentityData.step2Failed">
                  <!-- CCR3-17210 Design Language Selection Dropdown on AIDV Delivery Step 2 -->
      <p class="hide">If the caller is speaking a language different from the default, ask if they would like the message sent in their preferred language. If yes, update the language dropdown accordingly.</p>
                  <div class="row row-bottom-space hide">
         <div class="language-selection col-md-6">
    <app-alight-smart-search-drop-down [group]="languageForm" [controlName]="'language'" [required]="false"
      description="clientName" [clearSeleAvailable]="true" [disable]="false" label="Language"
      [value]="'clientName'" [list]="languageOptions">
    </app-alight-smart-search-drop-down>
  </div>
      </div>
                  <p>Enter a valid mobile number or email address to receive the verification link.</p>
                  <div class="container">
                    <div class="row row-bottom-space">
                      <div class="col-md-6">
                        <f-intl-tel-input 
                          [value]="activeTab.clearIdentityData.mobileNumber"
                          [defaultCountry]="activeTab.clearIdentityData.countryCode || 'US'" [hideDropdown]="activeTab.clearIdentityData.mobileNumber.length > 0"
                          language="en-US"
                          mandatory-country-code="true"
                          label-text="Mobile number"
                          appAutoCompleteOff
                          class="clear-input"
                          [disabled]="activeTab.clearIdentityData.email.length > 0"
                          (telInputChanged)="onTelInputChange($event)">
                        </f-intl-tel-input>
                      </div>
                
                    </div>
                
                    <div class="row">
                      <div class="col-md-6">

                        <mat-form-field appearance="fill" class="component-box">
                          <mat-label>Email address</mat-label>
                          <input matInput type="email" name="email" #email="ngModel" email appAutoCompleteOff [(ngModel)]="activeTab.clearIdentityData.email"
                             [disabled]="activeTab.clearIdentityData.mobileNumber.length > 0" [pattern]="patterns.EMAIL">
                        <mat-error *ngIf="email.invalid && (email.dirty || email.touched)">
                          Invalid Email address. </mat-error>
                        </mat-form-field>
                      
                      </div>
                
                    </div>
                
                
                
                
                  </div>
                  
                
                </div>
                <div class="pin-content step2-content" *ngIf="activeTab.clearIdentityData.step2Failed">
                  <!-- Step 2 Error State f-alert -->
                  <section class="error-wrapper" >
                    <f-alert variant="error">
                      <p *ngIf="activeTab.clearIdentityData.step2ErrorMsg">{{activeTab.clearIdentityData.step2ErrorMsg}}</p>
                      <p *ngIf="!activeTab.clearIdentityData.step2ErrorMsg">
                        Something went wrong.<button class="btn-alert" (click)="onClicktryAgain()">Try again.</button>
                      </p>
                    </f-alert>
                  </section>
                </div>

                <!-- Step 3 for AIDV content -->
                <section class="pin-content step3-content" *ngIf="activeTab.clearIdentityData?.step3Active">
                  <section class="error-wrapper" *ngIf="activeTab.clearIdentityData.step3InfoMsg&&!activeTab.clearIdentityData.exceededTimeLimit">
                    <f-alert variant="info">
                      <p>{{activeTab.clearIdentityData.step3InfoMsg}}</p>
                    </f-alert>

                  </section>
                  
                  <div *ngIf="!activeTab.clearIdentityData.step3Complete && !activeTab.clearIdentityData?.step3Failed&&!activeTab.clearIdentityData.exceededTimeLimit">
                    <p>The verification link has been sent to : <strong>{{activeTab.clearIdentityData.email || (activeTab.clearIdentityData.countryCode + " " + activeTab.clearIdentityData.mobileNumber)}}</strong> Please wait for the customer to
                      complete the upload and verification.</p>
                    <div class="text-with-loader flex">
                      <p>AIDV verification status: <strong>In progress </strong></p> <mat-progress-spinner class="section-loader"
                        [color]="color" [mode]="mode" [value]="value" [diameter]="16"
                        style="display:inline-block;"></mat-progress-spinner>
                        <p *ngIf="activeTab.clearIdentityData.timer>0" class="time-duration"> <span class="time">{{activeTab.clearIdentityData.timer | date: 'mm:ss' : 'UTC'}}</span> <span class="clock-icon">
                          <f-icon icon-config='{"iconName": "clock", "iconType": "light", "iconSize": "s"}'></f-icon></span></p>
                    </div>
                
                    <p>Sent at incorrect delivery method/address? <button class="btn-alert" (click)="onClickResendLink()">Resend Link</button>
                    </p>
                    <p>
                      <!-- [ngClass]="{'disabledLink': activeTab.clearIdentityData?.step3Active}" -->
                      <button class="btn-alert" (click)="onClickRefresh()" [ngClass]="{'disabledLink': clearService.clickButton}" [disabled]="clearService.clickButton"
                        >Click here</button>
                      only if the verification status is taking longer than expected.
                    </p>
                    <p>
                      <strong>Note:</strong> The caller needs to complete document upload within 15 minutes to avoid timeout.
                    </p>
                  </div>
                  <div *ngIf="activeTab.clearIdentityData.exceededTimeLimit">
                     <f-alert variant="warning"> Session expired. Click <button class="btn-alert" (click)="onClickResendLink()">Resend Link</button> to generate a new link.</f-alert>
                  </div>
                  <!-- Step 3 completed content with success state -->
                  <div>
                    <section class="error-wrapper status-msg" *ngIf="activeTab.clearIdentityData?.step3Complete">
                      <f-alert variant="success">
                        <strong>Success!</strong> Documents and selfie verified.
                      </f-alert>
                    </section>
                  </div>
                
                  <!-- Step 3 Error State f-alert -->
                  <div *ngIf="activeTab.clearIdentityData?.step3Failed">
                    <section class="error-wrapper" *ngIf="activeTab.clearIdentityData?.retryAttempts===0">
                      <f-alert variant="info">{{CL_constant.RETRY_ERROR_MSG}}</f-alert>
                    </section>
                    <section class="error-wrapper" *ngIf="underAge(activeTab.clearIdentityData.step3ErrorMsg)">
                      <f-alert variant="info">{{CL_constant.AGE_INFO_MSG}}</f-alert>
                    </section>
                   
                    <section class="error-wrapper">
                      <f-alert class="error-with-heading  " variant="error">
                        <p class="alert-top-heading">'AIDV Failed!'</p>
                          <ng-container *ngFor="let error of activeTab.clearIdentityData.step3ErrorMsg">
                            <p>{{error?.fieldValue?error.fieldValue:error?.errorMessage}}</p>
                          </ng-container>                         
                      </f-alert>
                    </section>
                    <p>1. Caller failed Alight Identity Verification. Check the “AIDV Failure Codes” link on the right for next steps.
                    </p>
                    <p>2. <button class="btn-alert" [ngClass]="{'disabledLink': activeTab.clearIdentityData?.retryAttempts===0 || underAge(activeTab.clearIdentityData.step3ErrorMsg)}" (click)="onClickRetry()" [disabled]="activeTab.clearIdentityData?.retryAttempts===0 || underAge(activeTab.clearIdentityData.step3ErrorMsg)">Retry</button> AIDV only if deemed appropriate, allowing the
                      customer to upload the documents and selfie again.</p>
                  </div>
                
                </section>
       

                <div class="btn-refresh-container flex" *ngIf="rootScope.activeCustTab.clearIdentityData.identityVerificationType === affidavitTypeConstants.ACCOUNT_ACCESS">
                  <div class="btn-controls">
                    <f-button [text]="CL_constant.CANCEL_BUTTON" [title]="CL_constant.CANCEL_BUTTON" *ngIf="enableCancel()"
                      type="button" variant="action" (buttonClicked)="onClickCancel()"></f-button>
                    <f-button *ngIf="enableStartADIV()" [text]="CL_constant.START_AIDV_BUTTON" [title]="CL_constant.START_AIDV_BUTTON"
                      [disabled]="disableStartADIV()" type="button" variant="progressive" class="hide1"
                      (buttonClicked)="onClickStartADIV()"></f-button>
                    <f-button [text]="CL_constant.CONTINUE_BUTTON" [title]="CL_constant.CONTINUE_BUTTON" *ngIf="enableContinue()"
                      type="button" variant="progressive" (buttonClicked)="onClickContinue()" [disabled]="disableContinue()"></f-button>
                    <f-button [text]="CL_constant.SUBMIT" [title]="CL_constant.SUBMIT" *ngIf="enableSubmit()"
                        type="button" variant="progressive" (buttonClicked)="onClickContinue()" [disabled]="disableSubmit()"></f-button>
                    <f-button [text]="CL_constant.CANCEL_AIDV_BUTTON" [title]="CL_constant.CANCEL_AIDV_BUTTON"
                      *ngIf="activeTab.clearIdentityData?.step3Active && !activeTab.clearIdentityData?.step3Complete && !activeTab.clearIdentityData?.step3Failed"
                      type="button" variant="destructive" (buttonClicked)="onClickCancelAidvProcess()"></f-button>
                  </div>
                </div>
              </div>
           
              
            </div>

  <!-- Fraud Affidavit Start -->           
<div class="clear-container fraud-affidavit-container" >
  <div class="pin-container hide1">
    <div class="step-container flex justify-space-between" *ngIf="activeTab.clearFraudIdentityData.step1Active">
      <!-- step-1 -->
      <span class="step-val" [ngClass]="{active:activeTab.clearFraudIdentityData.step1Active}">
        <span class="step-circle" [ngClass]="clearService.clearStepsClass('1')">
          <span class="hide1" *ngIf="activeTab.clearFraudIdentityData.step1Complete"> 
            <f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon>
          </span>
          <span class="step-no" *ngIf="!activeTab.clearFraudIdentityData?.step1Complete">1</span>
        </span>{{CL_constant.TITLE_STEP1}}
      </span>
      <!-- step-2 -->
      <span class="step-val" [ngClass]="{active:activeTab.clearFraudIdentityData.step2Active}">
        <span class="step-circle" [ngClass]="clearService.clearStepsClass('2')">
           <span class="hide1" *ngIf="activeTab.clearFraudIdentityData.step2Complete||activeTab.clearFraudIdentityData.step2Failed"> <f-icon [iconConfig]="{iconName: activeTab.clearFraudIdentityData.step2Failed ? 'xmark' : 'check', iconType: 'solid', iconSize: 's'}"></f-icon></span>
          <span class="step-no" *ngIf="!activeTab.clearFraudIdentityData?.step2Complete && !activeTab.clearFraudIdentityData?.step2Failed">2</span>
           
        </span>{{CL_constant.TITLE_STEP2}}
      </span>
      <!-- step-3 -->
      <span class="step-val" [ngClass]="{active:activeTab.clearFraudIdentityData.step3Active}">
        <span class="step-circle" [ngClass]="clearService.clearStepsClass('3')">
          <span class="hide1" *ngIf="activeTab.clearFraudIdentityData.step3Complete||activeTab.clearFraudIdentityData.step3Failed"> <f-icon [iconConfig]="{iconName: activeTab.clearFraudIdentityData.step3Failed ? 'xmark' : 'check', iconType: 'solid', iconSize: 's'}"></f-icon></span>
          <span class="step-no" *ngIf="!activeTab.clearFraudIdentityData?.step3Complete && !activeTab.clearFraudIdentityData?.step3Failed">3</span>
        </span>{{CL_constant.TITLE_STEP3}}
      </span>
    </div>
  </div>
  <div class="check-aidv-eligibility">

    <div *ngIf="activeTab.clearFraudIdentityData.step1Active && !activeTab.clearFraudIdentityData.step1Complete">
      <section class="error-wrapper">
        <f-alert variant="info"> {{CL_constant.STEP2PART2_INFO}}
        </f-alert>
      </section>
      <div class="pin-content step1-content">
        <p>{{CL_constant.STEP1PART2}}</p>

      </div>
      <section class="radio-selection">
        <mat-radio-group color="primary" class="account-selection" disableRipple aria-label="Select an option"
          [(ngModel)]="activeTab.clearFraudIdentityData.step1RadioSelection">
          <mat-radio-button *ngFor="let selection of accountAccessOptions " [value]="selection.value"
            (change)="fraudStep1RadioSelection($event.value)">
            <b>{{selection.value}} </b>{{selection.describe}}</mat-radio-button>
        </mat-radio-group>
      </section>
    </div>

    <!-- Step 2 for AIDV content -->
    <div class="pin-content step2-content" *ngIf="activeTab.clearFraudIdentityData?.step2Active && !activeTab.clearFraudIdentityData?.step3Active">
      <div class="error-wrapper hide1">
        <f-alert variant="info" *ngIf="!activeTab.clearFraudIdentityData?.step2ToggleSelection && !activeTab.clearFraudIdentityData?.step2Failed"> If the customer cannot
          obtain their valid government-issued ID within 5 minutes, instruct
          customer to call back to complete the verification process once they have it available. Press cancel to end
          AIDV.
        </f-alert>
        <f-alert variant="info" *ngIf="activeTab.clearFraudIdentityData?.step2ToggleSelection && !activeTab.clearFraudIdentityData?.step2Failed"> A mobile number or email
          address on file isn’t mandatory. Any mobile number or email
          address you can access may be used for verification.
        </f-alert>
        <div class="sm-selector" *ngIf="rootScope.activeCustTab.clearFraudIdentityData.step1RadioSelection !== 'Yes' && !activeTab.clearFraudIdentityData?.step2Failed">
          <span class="sm-title">Does the customer have their government-issued ID available now? </span>
          <f-toggle-switch label-left="No" label-right="Yes"
            [isOn]="activeTab.clearFraudIdentityData?.step2ToggleSelection"
            (toggleSwitchClicked)="onFraudToggleChange()">
          </f-toggle-switch>
        </div>
      </div>
      <div *ngIf="activeTab.clearFraudIdentityData?.step2ToggleSelection && !activeTab.clearFraudIdentityData?.step2Failed">
     
      <div class="pin-content step2-content">         
        <!-- CCR3-17210 Design Language Selection Dropdown on AIDV Delivery Step 2 -->
            <p class="hide">If the caller is speaking a language different from the default, ask if they would like the message sent in their preferred language. If yes, update the language dropdown accordingly.</p>
                  <div class="row row-bottom-space hide">
         <div class="language-selection col-md-6">
    <app-alight-smart-search-drop-down [group]="languageForm" [controlName]="'language'" [required]="false"
      description="clientName" [clearSeleAvailable]="true" [disable]="false" label="Language"
      [value]="'clientName'" [list]="languageOptions">
    </app-alight-smart-search-drop-down>
  </div>
      </div>
        <section class="radio-selection" id="mobileNumbersSection" >
          <mat-radio-group color="primary" class="account-selection custom-radio-selection" disableRipple aria-label="Select an option"
           [(ngModel)]="activeTab.clearFraudIdentityData.defaultSelectedValue"
            (change)="fraudStep2RadioSelection($event.value)">
             <p><strong>Text</strong></p>
            <ng-container *ngIf="rootScope.activeCustTab.clearFraudIdentityData.mobileNumbers?.length > 0">
              <mat-radio-button *ngFor="let selection of  rootScope.activeCustTab.clearFraudIdentityData.mobileNumbers "
                [value]="selection">
                <b>{{selection.countryCode}} </b>{{selection.phoneNumber}}
              </mat-radio-button>
            </ng-container>
                   
            <mat-radio-button [value]="customMobileOption" (focusin)="onCustomMobileFocus()">
              <f-intl-tel-input  [defaultCountry]="activeTab.clearFraudIdentityData.countryCode || 'US'" language="en-US"   [hideDropdown]="(activeTab.clearFraudIdentityData.mobileNumber.length > 0 && !activeTab.clearFraudIdentityData.isMobileSelected) || activeTab.clearFraudIdentityData.customMobileNumber.length > 0"
                mandatory-country-code="true" label-text="" helper-text="" appAutoCompleteOff class="clear-input"
                [disabled]="activeTab.clearFraudIdentityData.customEmail?.length > 0||activeTab.clearFraudIdentityData.isEmailSelected||activeTab.clearFraudIdentityData.isMobileSelected || activeTab.clearFraudIdentityData.isCustomEmailSelected" (telInputChanged)="onTelInputChange($event)">
              </f-intl-tel-input>
            </mat-radio-button>    
            
              <p><strong>Email</strong></p>
            <ng-container *ngIf="rootScope.activeCustTab.clearFraudIdentityData.emails?.length > 0">
            <mat-radio-button *ngFor="let selection of  rootScope.activeCustTab.clearFraudIdentityData.emails "
              [value]="selection">
              {{selection.emailAdress}}
            </mat-radio-button>
            </ng-container>
            <mat-radio-button class="custom-radio-width" [value]="customEmailOption">
              <mat-form-field appearance="fill" class="component-box">
                <mat-label>Email address</mat-label>
                <input matInput type="email" name="email" #email="ngModel" email appAutoCompleteOff
                  [(ngModel)]="activeTab.clearFraudIdentityData.customEmail"
                  (focus)="onCustomEmailFocus()"
                  [disabled]="activeTab.clearFraudIdentityData.mobileNumber?.length > 0 || activeTab.clearFraudIdentityData.isEmailSelected || activeTab.clearFraudIdentityData.isMobileSelected || activeTab.clearFraudIdentityData.isCustomMobileSelected" [pattern]="patterns.EMAIL">
                <mat-error *ngIf="email.invalid && (email.dirty || email.touched)">
                  Invalid Email address. </mat-error>
              </mat-form-field>
            </mat-radio-button>
          </mat-radio-group>
        
        </section>
     
      
      </div>
      
      </div>

      <!-- Step 2 Error State f-alert -->
        <section class="error-wrapper" *ngIf="activeTab.clearFraudIdentityData?.step2Failed">
          <f-alert variant="error">
            <p *ngIf="activeTab.clearFraudIdentityData?.step2ErrorMsg">{{activeTab.clearFraudIdentityData?.step2ErrorMsg}}</p>
            <p *ngIf="!activeTab.clearFraudIdentityData?.step2ErrorMsg">
              Something went wrong. <button class="btn-alert" (click)="onClicktryAgain(true)">Try again.</button>
            </p>
          </f-alert>
        </section>
     

    </div>


       <!-- Step 3 for AIDV content -->
                 <section class="pin-content step3-content" *ngIf="activeTab.clearFraudIdentityData?.step3Active">                  
                   <section class="error-wrapper" *ngIf="activeTab.clearFraudIdentityData.step3InfoMsg&&!activeTab.clearFraudIdentityData.exceededTimeLimit">
                    <f-alert variant="info">
                      <p>{{activeTab.clearFraudIdentityData.step3InfoMsg}}</p>
                    </f-alert>                 
                  </section>
                                
                  <div *ngIf="!activeTab.clearFraudIdentityData.step3Complete && !activeTab.clearFraudIdentityData?.step3Failed&&!activeTab.clearFraudIdentityData.exceededTimeLimit">
                    <p>The verification link has been sent to : <strong>{{(activeTab.clearFraudIdentityData.email?.trim() || activeTab.clearFraudIdentityData.customEmail?.trim()) || (activeTab.clearFraudIdentityData.countryCode + " " + activeTab.clearFraudIdentityData.mobileNumber)}}</strong> Please wait for the customer to
                      complete the upload and verification.</p>
                    <div class="text-with-loader flex">
                      <p>AIDV verification status: <strong>In progress </strong></p> <mat-progress-spinner class="section-loader"
                        [color]="color" [mode]="mode" [value]="value" [diameter]="16"
                        style="display:inline-block;"></mat-progress-spinner>
                        <p *ngIf="activeTab.clearFraudIdentityData.timer>0" class="time-duration"> <span class="time">{{activeTab.clearFraudIdentityData.timer | date: 'mm:ss' : 'UTC'}}</span> <span class="clock-icon">
                          <f-icon icon-config='{"iconName": "clock", "iconType": "light", "iconSize": "s"}'></f-icon></span></p>
                    </div>
                
                    <p>Sent at incorrect delivery method/address? <button class="btn-alert" (click)="onClickResendLink()">Resend Link</button>
                    </p>
                    <p>
                      <!-- [ngClass]="{'disabledLink': activeTab.clearIdentityData?.step3Active}" -->
                      <button class="btn-alert" [ngClass]="{'disabledLink': clearService.clickButton}" [disabled]="clearService.clickButton"  (click)="onClickRefresh()"
                        >Click here</button>
                      only if the verification status is taking longer than expected.
                    </p>
                    <p>
                      <strong>Note:</strong> The caller needs to complete document upload within 15 minutes to avoid timeout.
                    </p>
                  </div>
                  <div *ngIf="activeTab.clearFraudIdentityData.exceededTimeLimit">
                   <f-alert variant="warning">Session expired. Click <button class="btn-alert" (click)="onClickResendLink()">Resend Link</button> to generate a new link.</f-alert>
                  </div>
                  <!-- Step 3 completed content with success state -->
                  <div>
                    <section class="error-wrapper status-msg" *ngIf="activeTab.clearFraudIdentityData?.step3Complete">
                      <f-alert variant="success">
                        <strong>Success!</strong> Documents and selfie verified.
                      </f-alert>
                    </section>
                  </div>
                
                  <!-- Step 3 Error State f-alert -->
                  <div *ngIf="activeTab.clearFraudIdentityData?.step3Failed">
                    <section class="error-wrapper" *ngIf="activeTab.clearFraudIdentityData?.retryAttempts===0">
                      <f-alert variant="info">{{CL_constant.RETRY_ERROR_MSG}}</f-alert>
                    </section>
                    <section class="error-wrapper" *ngIf="underAge(activeTab.clearFraudIdentityData.step3ErrorMsg)">
                      <f-alert variant="info">{{CL_constant.AGE_INFO_MSG}}</f-alert>
                    </section>
                    <section class="error-wrapper">                      
                      <f-alert class="error-with-heading " variant="error">
                        <p class="alert-top-heading" *ngIf="rootScope.activeCustTab.clearIdentityData.identityVerificationType !== affidavitTypeConstants.ENHANCED_IDENTITY ">AIDV Failed!</p>
                        <p *ngIf="rootScope.activeCustTab.clearIdentityData.identityVerificationType === affidavitTypeConstants.ENHANCED_IDENTITY"><b>AIDV Failed!</b> {{CL_constant.EIV_FAILURE_MSG}}</p>
                        <ng-container *ngFor="let error of activeTab.clearFraudIdentityData.step3ErrorMsg">
                        <p>{{error?.fieldValue?error.fieldValue:error?.errorMessage}}</p>
                        </ng-container>                        
                      </f-alert>
                    </section>
                
                    <p>1. Caller failed Alight Identity Verification. Check the “AIDV Failure Codes” link on the right for next steps.
                    </p>
                    <p>2. <button class="btn-alert" [ngClass]="{'disabledLink': activeTab.clearFraudIdentityData?.retryAttempts===0 || underAge(activeTab.clearFraudIdentityData.step3ErrorMsg)}" (click)="onClickRetry(true)" [disabled]="activeTab.clearFraudIdentityData?.retryAttempts===0 || underAge(activeTab.clearFraudIdentityData.step3ErrorMsg)">Retry</button> AIDV only if deemed appropriate, allowing the
                      customer to upload the documents and selfie again.</p>
                  </div>
                
                </section>  

  

    <div class="btn-refresh-container flex" *ngIf="rootScope.activeCustTab.clearIdentityData.identityVerificationType === affidavitTypeConstants.FRAUD_PREVENTION || rootScope.activeCustTab.clearIdentityData.identityVerificationType === affidavitTypeConstants.ENHANCED_IDENTITY">
      <div class="btn-controls">
        <f-button [text]="CL_constant.CANCEL_BUTTON" [title]="CL_constant.CANCEL_BUTTON"
          *ngIf="activeTab.clearFraudIdentityData.step1Active && !activeTab.clearFraudIdentityData.step3Active && !activeTab.clearFraudIdentityData.step2Failed" type="button" variant="action"
          (buttonClicked)="fraudCancelBtn()"></f-button>
      
        <f-button [text]="CL_constant.CONTINUE_BUTTON" [title]="CL_constant.CONTINUE_BUTTON"
          *ngIf="activeTab.clearFraudIdentityData.step1Active &&  !this.rootScope.activeCustTab.clearFraudIdentityData.step1Complete"
          (buttonClicked)="fraudContinueBtn()" [disabled]="disableFraudContinueBtn()">
        </f-button>
           <f-button [text]="CL_constant.SUBMIT" [title]="CL_constant.SUBMIT" *ngIf="enableSubmit()"
                        type="button" variant="progressive" (buttonClicked)="fraudContinueBtn()" [disabled]="disableFraudSubmit()">
                      </f-button>
        <f-button [text]="CL_constant.CANCEL_AIDV_BUTTON" [title]="CL_constant.CANCEL_AIDV_BUTTON"
          *ngIf="activeTab.clearFraudIdentityData?.step3Active && !activeTab.clearFraudIdentityData?.step3Complete && !activeTab.clearFraudIdentityData?.step3Failed"
          type="button" variant="destructive" (buttonClicked)="onClickCancelAidvProcess()"></f-button>
      </div>
    </div>
  </div>


</div>
 <!-- Fraud Affidavit End -->

  <app-loader *ngIf="clearService.isSubmitBtnClicked" [loaderType]="loaderType"  ></app-loader>



